module.exports = __webpack_public_path__ + "assets/img/factory.56ec148d.png";